import { FC } from 'react';
import { renderMarkdown } from '../lib/renderMarkdown';

interface Props {
	markdown: string;
	theme: 'light' | 'dark';
}

// Рендерит текст поста ровно так, как он будет выглядеть в опубликованной
// статье (та же тема .article-content), с переключением light/dark.
const PostPreview: FC<Props> = ({ markdown, theme }) => {
	const hasContent = Boolean(markdown && markdown.trim());

	return (
		<div className='article-content article-preview' data-theme={theme}>
			{hasContent ? (
				<div dangerouslySetInnerHTML={{ __html: renderMarkdown(markdown) }} />
			) : (
				<div className='article-preview-empty'>
					Пока пусто — напишите текст, чтобы увидеть превью.
				</div>
			)}
		</div>
	);
};

export { PostPreview };
